import { Box, Icon, IconProps, IconSize, Text, TextProps } from '@bechtel/gds';
import { FC } from 'react';

interface ActionContentProps {
  icon: IconProps['icon'];
  label: string;
  labelSize?: TextProps['size'];
  labelWeight?: TextProps['weight'];
  labelFamily?: TextProps['family'];
  iconStyle?: IconProps['iconStyle'];
  iconSize?: IconSize;
  fillColor?: string;
}

export const ActionContent: FC<ActionContentProps> = ({
  icon,
  label,
  labelSize = '300',
  labelWeight = '600',
  labelFamily = 'openSans',
  iconStyle = undefined,
  fillColor = '',
  iconSize = IconSize.MEDIUM,
}) => {
  return (
    <Box alignItems={{ sm: 'center' }} px={{ sm: '300' }}>
      <Box mr={{ sm: '400' }}>
        <Icon icon={icon} iconStyle={iconStyle} fillColor={fillColor} size={iconSize} />
      </Box>
      <Text size={labelSize} weight={labelWeight} family={labelFamily}>
        {label}
      </Text>
    </Box>
  );
};
